<ng-container *transloco="let t">
<form #addressForm="ngForm" novalidate id="addressForm{{uniqueId}}" name="addressForm{{uniqueId}}">
  @if (canSetTbd) {
    <div class="row mb-2">
      <div class="form-check ms-2">
        <input class="form-check-input" [(ngModel)]="isTbd" (ngModelChange)="onIsTbdChanged()" type="checkbox" value=""
          id="isTbd" [disabled]="isTbdDisabled || tbdLockedByExistingAddress" name="isTbd">
        @if (!inEditMode) {
          <label class="form-check-label fs-6 fw-bold" for="isTbd">
            {{ addressTbdLabel || t('common.tbd') }}
          </label>
        }
        @if (inEditMode) {
          <input name="tbdLabel" type="text" class="form-control  form-control-solid fw-bolder"
            [(ngModel)]="addressTbdLabel" (blur)="onAddressTbdLabelChanged()" />
        }
      </div>
    </div>
  }
  @if (isTbd && !requireUserToEnterZipCodeWhenTbd) {
    <div class="row mb-2 rounded" [ngClass]="{
                'is-invalid' : doYouKnowTheZipQuestion && doYouKnowTheZipQuestion.touched && doYouKnowTheZipQuestion.invalid,
                'border' : doYouKnowTheZipQuestion && doYouKnowTheZipQuestion.touched && doYouKnowTheZipQuestion.invalid,
                'p-4' : doYouKnowTheZipQuestion && doYouKnowTheZipQuestion.touched && doYouKnowTheZipQuestion.invalid,
                'border-danger' : doYouKnowTheZipQuestion && doYouKnowTheZipQuestion.touched && doYouKnowTheZipQuestion.invalid
              }">
      <div class="col-md-6 col-sm-12 fs-6 text-dark mb-3" style="padding-top: 4px;">{{ t('wizard.address.zipKnownQuestion') }}
      </div>
      <div class="col-md-2 col-sm-12 mb-3">
        <div class="d-flex">
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" name="isZipKnownByTheBorrower" required [value]="true" type="radio"
              id="yesForZipCode" [(ngModel)]="isZipKnownByTheBorrower" #doYouKnowTheZipQuestion="ngModel"
              (ngModelChange)="onAnswerForZipcodeQuestionChanged()" />
            <label style="padding-right: 6px;" class="form-check-label" for="yesForZipCode">{{ t('common.yes') }}</label>
          </div>
          <div class="form-check form-check-custom form-check-solid ms-8">
            <input class="form-check-input" name="isZipKnownByTheBorrower" required [value]="false" type="radio"
              id="noForZipCode" [(ngModel)]="isZipKnownByTheBorrower" #doYouKnowTheZipQuestion="ngModel"
              (ngModelChange)="onAnswerForZipcodeQuestionChanged()" />
            <label style="padding-right: 6px;" class="form-check-label" for="noForZipCode">{{ t('common.no') }}</label>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!isTbd || isZipKnownByTheBorrower || (requireUserToEnterZipCodeWhenTbd && isTbd)) {
    <div class="d-flex mb-5 row">
      <!-- Address Field (shown when !isTbd) -->
      @if (!isTbd && !isHidden(fieldConfigSettings.addressField)) {
        <div class="col-md-{{showCounty ? '3' : '4'}}">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': required && !isTbd && isRequired(fieldConfigSettings.addressField)}">
              {{getLabel(fieldConfigSettings.addressField, t('wizard.address.address'))}}
            </span>
          </label>
          <address-autocomplete-v2
            [name]="'address11' + uniqueId"
            [id]="'address11' + uniqueId"
            [(ngModel)]="address!.address1"
            [required]="required && isRequired(fieldConfigSettings.addressField)"
            [placeholder]="t('wizard.address.enterAddress')"
            (addressSelected)="onAddressSelectedWithAutoComplete($event)">
          </address-autocomplete-v2>
          <!-- <div class="invalid-feedback">Address is required, please enter an address.</div> -->
        </div>
      }

      <!-- Zip Code Field (shown when isTbd) -->
      @if (isTbd && zipCodeLookupEnabled && !isHidden(fieldConfigSettings.zipCodeField)) {
        <div class="col-md-3 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span
              [ngClass]="{'required': required && isRequired(fieldConfigSettings.zipCodeField) && ((isTbd && !requireUserToEnterZipCodeWhenTbd) || !isTbd) && (!isTbd || isZipKnownByTheBorrower) && !(address.country && address.country !== 'us')}">
              {{getLabel(fieldConfigSettings.zipCodeField, t('wizard.address.zipCode'))}}
            </span>
          </label>
          <div class="input-group">
            <input type="text" #control [(ngModel)]="address!.zipCode" [mask]="mask" [placeholder]="placeHolder"
              [pattern]="pattern"
              [required]="required && isRequired(fieldConfigSettings.zipCodeField) && ((isTbd && !requireUserToEnterZipCodeWhenTbd) || !isTbd) && (!isTbd || isZipKnownByTheBorrower) && !(address.country && address.country !== 'us')"
              [ngClass]="{'is-invalid' : zipCode && zipCode.touched && zipCode.invalid}"
              [disabled]="address.country && address.country !== 'us'" class="form-control form-control-solid"
              (keydown)="onKeyDownOnAddress($event)" (blur)="onAddressBlurred($event)" placeholder=""
              name="zipCode{{uniqueId}}" #zipCode="ngModel" #zipCodeOfAddress id="zipCode{{uniqueId}}" />
            <span class="input-group-append" style="z-index: 1;">
              <button class="btn btn-default border" type="button" id="search-zip-code-btn"
                (click)="searchZipcode(selectionsDropdown)">
                @if (loadingZipcodes) {
                  <span class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                }

                @if (!loadingZipcodes) {
                  <i class="fa fa-search"></i>
                }
              </button>
            </span>
            @if (zipCode.errors && zipCode.errors.pattern) {
              <div class="invalid-feedback">
                {{ t('wizard.address.invalidFormat') }}
              </div>
            }
          </div>
          <div ngbDropdown #selectionsDropdown="ngbDropdown" class="w-100">
            <a ngbDropdownToggle style="display: none"></a>
            <div ngbDropdownMenu class="w-100 overflow-auto">
              @if (suggestions.length == 0) {
                <span class="mx-2">{{ t('wizard.address.noRecordsFound') }}</span>
              }
              @for (suggestion of suggestions; track $index) {
                <button ngbDropdownItem type="button" class="px-1"
                  (click)="selectZipcode(suggestion)">
                  {{ suggestion.city }} / {{ suggestion.county }} , {{ suggestion.state }}
                </button>
              }
            </div>
          </div>
        </div>
      }

      <!-- City Field -->
      @if (!isHidden(fieldConfigSettings.cityField)) {
        <div class="col-md-{{isTbd ? '4' : (showCounty ? '2' : '3')}}">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': required && !isTbd && isRequired(fieldConfigSettings.cityField)}">
              {{getLabel(fieldConfigSettings.cityField, t('wizard.address.city'))}}
            </span>
          </label>
          <div class="position-relative">
            <input type="text" class="form-control form-control-solid" [(ngModel)]="address!.city"
              (change)="onAddressChanged()" [required]="required && !isTbd && isRequired(fieldConfigSettings.cityField)" placeholder="" name="city{{uniqueId}}"
              [ngClass]="{'is-invalid' : city && city.touched && city.invalid}" #city="ngModel" #cityOfAddress
              id="city{{uniqueId}}" />
            <!-- <div class="invalid-feedback">City is required, please enter a city.</div> -->
          </div>
        </div>
      }

      <!-- County Field -->
      @if (showCounty && !isHidden(fieldConfigSettings.countyField)) {
        <div class="col-md-{{isTbd ? '3' : '2'}}">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': required && !isTbd && isRequired(fieldConfigSettings.countyField)}">
              {{getLabel(fieldConfigSettings.countyField, t('wizard.address.county'))}}
            </span>
          </label>
          <div class="position-relative">
            <county-autocomplete-input
              id="borrowerCounty{{uniqueId}}" name="borrowerCounty{{uniqueId}}"
              inputClass="form-control form-control-solid" [(ngModel)]="address!.county"
              [includedPrimaryTypes]="['administrative_area_level_2']" [regionCodes]="['US']"
              [required]="required && !isTbd && isRequired(fieldConfigSettings.countyField)"
              (selected)="onCountySelected($event)" (blur)="onAddressChanged()"
              [ngClass]="{'is-invalid': county && county.touched && county.invalid}"
              #county="ngModel">
            </county-autocomplete-input>
          </div>
        </div>
      }

      <!-- State Field -->
      @if (!isHidden(fieldConfigSettings.stateField)) {
        <div class="col-md-2 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span
              [ngClass]="{'required': (required && isRequired(fieldConfigSettings.stateField)) && !(address.country && address.country !== 'us')}">
              {{getLabel(fieldConfigSettings.stateField, t('wizard.address.state'))}}
            </span>
          </label>
          <select name="state{{uniqueId}}"
            [required]="(required && isRequired(fieldConfigSettings.stateField)) && !(address.country && address.country !== 'us')"
            [ngClass]="{'is-invalid' : state && state.touched && state.invalid}" [(ngModel)]="address!.state"
            (change)="onAddressChanged()" class="form-select form-select-solid" #state="ngModel" #stateOfAddress
            id="state{{uniqueId}}" [attr.data-placeholder]="t('wizard.address.selectState')"
            [disabled]="address.country && address.country !== 'us'">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            @for (state of states; track state.value) {
              <option value="{{state.value}}">
                {{state.name}}
              </option>
            }
          </select>
          <!-- <div class="invalid-feedback">State is required, please select a state.</div> -->
        </div>
      }

      <!-- Zip Code Field (shown when !isTbd && !zipCodeLookupEnabled) -->
      @if (!isTbd && !zipCodeLookupEnabled && !isHidden(fieldConfigSettings.zipCodeField)) {
        <div class="fv-row col-md-{{showCounty ? '2' : '3'}}">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span
              [ngClass]="{'required': required && isRequired(fieldConfigSettings.zipCodeField) && ((isTbd && !requireUserToEnterZipCodeWhenTbd) || !isTbd) && (!isTbd || isZipKnownByTheBorrower) && !(address.country && address.country !== 'us')}">
              {{getLabel(fieldConfigSettings.zipCodeField, t('wizard.address.zipCode'))}}
            </span>
          </label>
          <div class="position-relative">
            <input type="text" [(ngModel)]="address!.zipCode" (change)="onAddressChanged()"
              [required]="required && isRequired(fieldConfigSettings.zipCodeField) && ((isTbd && !requireUserToEnterZipCodeWhenTbd) || !isTbd) && (!isTbd || isZipKnownByTheBorrower) && !(address.country && address.country !== 'us')"
              [ngClass]="{'is-invalid' : zipCode && zipCode.touched && zipCode.invalid}" numeric inputmode="numeric"
              [disabled]="address.country && address.country !== 'us'" class="form-control form-control-solid"
              placeholder="" name="zipCode{{uniqueId}}" #zipCode="ngModel" #zipCodeOfAddress id="zipCode{{uniqueId}}" />
            <!-- <div class="invalid-feedback">Zip code is required, please enter a zip code.</div> -->
          </div>
        </div>
      }

      <!-- Zip Code Field with (shown when !isTbd && zipCodeLookupEnabled) -->
      @if (!isTbd && zipCodeLookupEnabled && !isHidden(fieldConfigSettings.zipCodeField)) {
        <div class="col-md-3 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span
              [ngClass]="{'required': required && isRequired(fieldConfigSettings.zipCodeField) && ((isTbd && !requireUserToEnterZipCodeWhenTbd) || !isTbd) && (!isTbd || isZipKnownByTheBorrower) && !(address.country && address.country !== 'us')}">
              {{getLabel(fieldConfigSettings.zipCodeField, t('wizard.address.zipCode'))}}
            </span>
          </label>
          <div class="input-group">
            <input type="text" #control [(ngModel)]="address!.zipCode" [mask]="mask" [placeholder]="placeHolder"
              [pattern]="pattern"
              [required]="required && isRequired(fieldConfigSettings.zipCodeField) && ((isTbd && !requireUserToEnterZipCodeWhenTbd) || !isTbd) && (!isTbd || isZipKnownByTheBorrower) && !(address.country && address.country !== 'us')"
              [ngClass]="{'is-invalid' : zipCode && zipCode.touched && zipCode.invalid}"
              [disabled]="address.country && address.country !== 'us'" class="form-control form-control-solid"
              placeholder="" name="zipCode{{uniqueId}}" #zipCode="ngModel" #zipCodeOfAddress id="zipCode{{uniqueId}}" />
            <span class="input-group-append" style="z-index: 1;">
              <button class="btn btn-default border" type="button" id="search-zip-code-btn"
                (click)="searchZipcode(selectionsDropdown)">
                @if (loadingZipcodes) {
                  <span class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                }

                @if (!loadingZipcodes) {
                  <i class="fa fa-search"></i>
                }
              </button>
            </span>
            @if (zipCode.errors && zipCode.errors.pattern) {
              <div class="invalid-feedback">
                {{ t('wizard.address.invalidFormat') }}
              </div>
            }
          </div>
          <div ngbDropdown #selectionsDropdown="ngbDropdown" class="w-100">
            <a ngbDropdownToggle style="display: none"></a>
            <div ngbDropdownMenu class="w-100 overflow-auto">
              @if (suggestions.length == 0) {
                <span class="mx-2">{{ t('wizard.address.noRecordsFound') }}</span>
              }
              @for (suggestion of suggestions; track $index) {
                <button ngbDropdownItem type="button" class="px-1"
                  (click)="selectZipcode(suggestion)">
                  {{ suggestion.city }} / {{ suggestion.county }} , {{ suggestion.state }}
                </button>
              }
            </div>
          </div>
        </div>
      }

      <!-- Country Field -->
      @if (showCountry && !isHidden(fieldConfigSettings.countryField)) {
        <div class="col-md-4 fv-row mt-2">
          <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
            <span [ngClass]="{'required': required && !isTbd && isRequired(fieldConfigSettings.countryField)}">
              {{getLabel(fieldConfigSettings.countryField, t('wizard.address.country'))}}
            </span>
            @if (loadingCountries) {
              <span class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
            }
          </label>
          <select name="country{{uniqueId}}" [required]="required && !isTbd && isRequired(fieldConfigSettings.countryField)"
            [ngClass]="{'is-invalid' : country && country.touched && country.invalid}" [(ngModel)]="address!.country"
            (change)="onCountryChanged()" class="form-select form-select-solid" #country="ngModel" #countryOfAddress
            id="country{{uniqueId}}" [attr.data-placeholder]="t('wizard.address.selectCountry')" [disabled]="loadingCountries">
            @if (loadingCountries) {
              <option [ngValue]="null">{{ t('common.loading') }}</option>
            } @else {
              <option [ngValue]="null">{{ t('common.selectOne') }}</option>
              @for (country of countries; track country.alpha2) {
                <option value="{{country.alpha2}}">
                  {{country.name}}
                </option>
              }
            }
          </select>
          <!-- <div class="invalid-feedback">Country is required, please select a country.</div> -->
        </div>
      }
    </div>
  }
</form>
</ng-container>
